import React from 'react';
import { Link } from 'react-router-dom';
import
{
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown
} from 'reactstrap';

import { linkStyle } from './linkStyle';

function OkafMenu()
{
    const okafMenu = [
        { name: "Hakkımızda", url: "/hakkimizda", blank: "/" },
        // { name: "Paydaş Üniversiteler", url: "/paydaslar", blank: "/" },
        { name: "Danışma Kurulu", url: "/danisma", blank: "/" },
        { name: "Düzenleme Kurulu", url: "/duzenleme", blank: "/" },
        { name: "Koordinasyon Kurulu", url: "/koordinasyon", blank: "/" },
        // { name: "Katalog", url: "/katalog", blank: "/" }
    ];

    /*
    // ORNEK KULLANIM
    const handleClick = () => {
        var customDropdown = document.getElementById('customDropdown');
        var dropdownMenu = customDropdown.querySelector('.dropdown-menu');
        customDropdown.addEventListener('mouseenter', function() {
            if (!dropdownMenu.classList.contains('show')) {
                customDropdown.querySelector('.dropdown-toggle').click();
            }
        });
        dropdownMenu.addEventListener('mouseleave', function() {
            if (dropdownMenu.classList.contains('show')) {
                customDropdown.querySelector('.dropdown-toggle').click();
            }
        });
    };
    */
    return (
        <UncontrolledDropdown nav inNavbar id="customDropdown">
            <DropdownToggle nav caret>
                OKAF
            </DropdownToggle>
            <DropdownMenu right>
                {okafMenu.map((item, index) => (
                    <DropdownItem key={index}>
                        <Link to={item.url}>
                            {item.name}
                        </Link>
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </UncontrolledDropdown>
    );


}




export default OkafMenu;

